import React from "react";
import { errorToast } from "./common/showtoast";
import PageHeader from "./common/pageheader";
import ApiRequest from "./common/restservice";
import assetimages from "./common/assetimages";

export default class JoiningInvoice extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      amount1: 0,
      amount2: 0,
      billing_address1: "",
      billing_address2: "",
      billing_address3: "",
      billing_city: "",
      billing_district: "",
      billing_pincode: "",
      billing_state: "",
      customerid: "",
      desc1: "",
      desc2: "",
      invoicedate: "",
      invoiceno: "",
      qty1: "",
      qty2: "",
      shipping_address1: "",
      shipping_address2: "",
      shipping_city: "",
      shipping_district: "",
      shipping_pincode: "",
      shipping_state: "",
      total: 0,
      unit_price1: 0,
      billdata: [],
      unit_price2: 0,
    }
  }
  componentDidMount() {
    if (this.props.match && this.props.match.params)
      this.GetTransactions(this.props.match.params.billno);
  }
  async GetTransactions(billno) {
    console.log(billno);
    let res = await ApiRequest("invoicedetails.asp", "POST", { Billnumber: billno }, { Authorization: localStorage.getItem("token") });
    console.log(res);
    if (res.status === "error") {
      errorToast(res.message);
      if (res.message === "Session Expired") {
        localStorage.clear();
        this.props.history.push("/login");
      }
      return;
    }
    this.setState(res);
  }
  render() {
    return (
      <div>
        <PageHeader title="Joining Invoice" />
        <div className="row">
          <div className="col-xl-12 col-lg-12 col-md-12">
            <div className="card">
              <div className="card-header">
                <h3 className="card-title text-color-1" style={{ fontWeight: "200", fontSize: "22px" }}>
                                    Invoice
                </h3>
              </div>
              <div className="card-body">
                <div className="row">
                  <div className="col-lg-6">
                    <div style={{ color: "gray" }}>
                      <img src={assetimages.logo} style={{ maxWidth: "150px" }} alt="" />
                      {/* <h3 className="mt-2">Orga Enviro Private Limited</h3>
                                            <h5>No.38A,Karunigar Street,<br />Nerkundram, Chennai,
                                            <br />Tamilnadu, India - 600107.<br />
                                            PH:-044 4555542369</h5> */}
                      <div style={{ border: "1px solid lightgray", padding: "5px 10px", backgroundColor: "#dbe7f1" }}>
                                                Bill To
                      </div>
                      <h5 className="ml-5 mt-2">{this.state.billing_address1},
                        <br />{this.state.billing_address2},
                        <br />{this.state.billing_city},
                        <br />{this.state.billing_state} - {this.state.billing_pincode}.
                      </h5>
                    </div>
                  </div>
                  <div className="col-lg-6">
                    <h1 className="text-center mt-5 mb-5">Invoice</h1>
                    <table className="table text-center mt-5" border="1">
                      <tbody>
                        <tr>
                          <td style={{ padding: ".25rem", backgroundColor: "#dbe7f1" }}>Invoice #</td>
                          <td style={{ padding: ".25rem", backgroundColor: "#dbe7f1" }}>Date</td>
                        </tr>
                        <tr>
                          <td style={{ padding: ".25rem" }}>{this.state.invoiceno}</td>
                          <td style={{ padding: ".25rem" }}>{this.state.invoicedate}</td>
                        </tr>
                        <tr>
                          <td style={{ padding: ".25rem", backgroundColor: "#dbe7f1" }}>Customer ID</td>
                          <td style={{ padding: ".25rem", backgroundColor: "#dbe7f1" }}>Terms $</td>
                        </tr>
                        <tr>
                          <td style={{ padding: ".25rem" }}>{this.state.customerid}</td>
                          <td style={{ padding: ".25rem" }}>1 Time</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
                <div className="row mt-5">

                  {/* <div className="col-lg-6">
                                        <div style={{ border: "1px solid lightgray", padding: "5px 10px", backgroundColor: "#dbe7f1" }}>
                                            Ship To
                                        </div>
                                        <h5 className="ml-5 mt-2">{this.state.shipping_address1},
                                            <br />{this.state.shipping_address2},
                                            <br />{this.state.shipping_city},
                                            <br />{this.state.shipping_state} - {this.state.shipping_pincode}.
                                        </h5>
                                    </div> */}
                </div>
                <div className="row table-responsive mt-5">
                  <table className="table text-center" border="1">
                    <thead>
                      <tr>
                        <th style={{ backgroundColor: "#dbe7f1" }}>S.NO</th>
                        <th style={{ backgroundColor: "#dbe7f1" }}>PRODUCT ID</th>
                        <th style={{ backgroundColor: "#dbe7f1" }}>BILL NUMBER</th>
                        <th style={{ backgroundColor: "#dbe7f1" }}>QTY</th>
                        <th style={{ backgroundColor: "#dbe7f1" }}>BV</th>
                        <th style={{ backgroundColor: "#dbe7f1" }}>AMOUNT</th>
                      </tr>
                    </thead>
                    <tbody>
                      {
                        this.state.billdata.map((item, index) => {
                          return <tr key={index}>
                            <td>{(index + 1)}</td>
                            <td>{item.Ref}</td>
                            <td>{item.ProductID}</td>
                            <td>{item.qty}</td>
                            <td>{item.BV}</td>
                            <td>{item.amount}</td>
                          </tr>
                        })
                      }
                      <tr style={{ height: "40px", backgroundColor: "white" }}>
                        <td colSpan="3"></td>
                        <td></td>
                        <td></td>
                        <td></td>

                      </tr>
                      <tr style={{ height: "40px", backgroundColor: "white" }}>
                        <td colSpan="3"></td>
                        <td></td>
                        <td></td>
                        <td></td>

                      </tr>
                      <tr style={{ height: "40px", backgroundColor: "white" }}>
                        <td colSpan="3"></td>
                        <td></td>
                        <td></td>
                        <td></td>
                      </tr>
                      <tr></tr>
                      <tr>
                        <td colSpan="3"><span>Thank you for your business!</span></td>
                        <td colSpan="2">Total</td>
                        <td>{this.state.totalMRP}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}